import {z} from 'zod';

export default z.object({
    withHeadings: z.boolean().optional().default(true),
    content: z.array(z.array(z.string().optional())).optional()
});
